module.exports = __webpack_public_path__ + "static/media/chat.c846f84e.png";